import React from 'react';
import CuentaForm from 'views/Matriculates/CuentaForm';

export default function Account() {
  return <CuentaForm title="Mi Cuenta" />;
}
